<template>
    <div class="list-product-card">
        <div class="list-product-card-inner">
            <div class="product-card-left">
                <a :href="comboUrl" class="product-image">
                    <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product-image">

                    <ul class="list-inline product-badge">
                        <li class="badge badge-danger" v-if="combo.is_out_of_stock">
                            {{ $trans('storefront::combo_card.out_of_stock') }}
                        </li>

                        <li class="badge badge-primary" v-else-if="combo.is_new">
                            {{ $trans('storefront::combo_card.new') }}
                        </li>

                        <li class="badge badge-success" v-if="combo.has_percentage_special_price">
                            -{{ combo.special_price_percent }}%
                        </li>
                    </ul>
                </a>
            </div>

            <div class="product-card-right">
                <a :href="comboUrl" class="product-name">
                    <h6>{{ combo.name }}</h6>
                </a>

                <div class="clearfix"></div>

                <!-- <ComboRating :ratingPercent="combo.rating_percent" :reviewCount="combo.reviews.length"/> -->

                <div class="product-price" v-html="combo.formatted_price"></div>

                <button
                    v-if="hasNoOption || combo.is_out_of_stock"
                    class="btn btn-default btn-add-to-cart"
                    :class="{ 'btn-loading': addingToCart }"
                    :disabled="combo.is_out_of_stock"
                    @click="addToCart"
                >
                    <i class="las la-cart-arrow-down"></i>
                    {{ $trans('storefront::combo_card.add_to_cart') }}
                </button>

                <a
                    v-else
                    :href="comboUrl"
                    class="btn btn-default btn-add-to-cart"
                >
                    <i class="las la-eye"></i>
                    {{ $trans('storefront::combo_card.view_options') }}
                </a>

                <div class="product-card-actions">
                    <button
                        class="btn btn-wishlist"
                        :class="{ 'added': inWishlist }"
                        @click="syncWishlist"
                    >
                        <i class="la-heart" :class="inWishlist ? 'las' : 'lar'"></i>
                        {{ $trans('storefront::combo_card.wishlist') }}
                    </button>

                    <button
                        class="btn btn-compare"
                        :class="{ 'added': inCompareList }"
                        @click="syncCompareList"
                    >
                        <i class="las la-random"></i>
                        {{ $trans('storefront::combo_card.compare') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import ComboRating from './../../ComboRating.vue';
    import ComboCardMixin from '../../../mixins/ComboCardMixin';

    export default {
        components: {  }, //ComboRating

        mixins: [
            ComboCardMixin,
        ],

        props: ['combo'],
    };
</script>
